import { HamburgerIcon } from '@chakra-ui/icons';
import {
  useDisclosure,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Stack,
  Box,
  Divider,
  Link,
} from '@chakra-ui/react';
import React from 'react';
import { NavigationBarProps } from '..';
import { Link as RouterLink } from 'react-router-dom';
import { CONSOLE_ROOT_PATH, REGISTER_PAGE_PATH } from '@/routes/path';

const MobileNavigation: React.VFC<NavigationBarProps> = ({
  t,
  scrollToShowcases,
  scrollToFeatures,
  scrollToPricing,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef(null);

  const postMenuSelect = (event: () => void) => () => {
    onClose();
    return setTimeout(() => {
      event();
    }, 500);
  };

  return (
    <>
      <Button ref={btnRef} variant="ghost" onClick={onOpen}>
        <HamburgerIcon boxSize="6" cursor="pointer" />
      </Button>
      <Drawer finalFocusRef={btnRef} isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader />
          <DrawerBody mt="2">
            <Stack spacing="4">
              <Stack>
                <Box
                  _hover={{ background: 'gray.100', cursor: 'pointer' }}
                  p="2"
                  rounded="md"
                  w="full">
                  {t('homepage')}
                </Box>
                <Box
                  _hover={{ background: 'gray.100', cursor: 'pointer' }}
                  p="2"
                  rounded="md"
                  w="full"
                  onClick={postMenuSelect(scrollToFeatures)}>
                  {t('feature')}
                </Box>
                {/* <Box
                  _hover={{ background: 'gray.100', cursor: 'pointer' }}
                  p="2"
                  rounded="md"
                  w="full"
                  onClick={postMenuSelect(scrollToShowcases)}
                >
                  {t('showcase')}
                </Box> */}
                <Box
                  _hover={{ background: 'gray.100', cursor: 'pointer' }}
                  p="2"
                  rounded="md"
                  w="full"
                  onClick={postMenuSelect(scrollToPricing)}>
                  {t('pricing')}
                </Box>
              </Stack>
              <Divider />
              {/* <Stack>
                <Box>
                  <Link
                    as={RouterLink}
                    target="_blank"
                    to={REGISTER_PAGE_PATH}
                    variant="no-decoration">
                    <Button colorScheme="blue" variant="solid" w="100%">
                      {t('sign_up_landing_page')}
                    </Button>
                  </Link>
                </Box>
                <Box>
                  <Link
                    as={RouterLink}
                    target="_blank"
                    to={CONSOLE_ROOT_PATH}
                    variant="no-decoration">
                    <Button colorScheme="blue" variant="outline" w="100%">
                      {t('sign_in')}
                    </Button>
                  </Link>
                </Box>
              </Stack> */}
            </Stack>
          </DrawerBody>
          <DrawerFooter />
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MobileNavigation;
